import tableSportRoomTeams from './tableRelatedSportRoomTeams';

export default {
  title: 'Teams',
  attributeName: 'appTeam',
  getURL: 'appId/appTeam',
  createURL: '',
  updateURL: '',
  removeURL: '',
  itemName: 'short',
  itemId: 'id',
  sessionParams: ['appId'],
  tableConfig: tableSportRoomTeams,
};
